import { msalInstance, loginRequest } from "@/authConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function getAuthHeaders() {
  const account = msalInstance.getActiveAccount();
  if (!account) return {};
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return { Authorization: `Bearer ${response.idToken}` };
  } catch {
    return {};
  }
}

async function request(url, options = {}) {
  const authHeaders = await getAuthHeaders();
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...authHeaders, ...options.headers },
    ...options,
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(err);
  }
  return res.json();
}

async function authedFetch(url, options = {}) {
  const authHeaders = await getAuthHeaders();
  return fetch(url, { ...options, headers: { ...authHeaders, ...options.headers } });
}

export const api = {
  getProjects: () => request(`${API}/projects`),
  getProject: (id) => request(`${API}/projects/${id}`),
  getNextId: () => request(`${API}/projects/next-id`).then(d => d.id),
  createProject: (project) => request(`${API}/projects`, { method: 'POST', body: JSON.stringify(project) }),
  updateProject: (id, project) => request(`${API}/projects/${id}`, { method: 'PUT', body: JSON.stringify(project) }),
  deleteProject: (id) => authedFetch(`${API}/projects/${id}`, { method: 'DELETE' }),
  lockProject: (id, passkey) => request(`${API}/projects/${id}/lock`, { method: 'POST', body: JSON.stringify({ passkey }) }),
  unlockProject: (id, passkey) => request(`${API}/projects/${id}/unlock`, { method: 'POST', body: JSON.stringify({ passkey }) }),
  saveActualResources: (id, actualResources) => request(`${API}/projects/${id}/actual-resources`, { method: 'PUT', body: JSON.stringify({ actualResources }) }),

  getAdhocInvoices: () => request(`${API}/invoices/adhoc`),
  createAdhocInvoice: (inv) => request(`${API}/invoices/adhoc`, { method: 'POST', body: JSON.stringify(inv) }),
  updateAdhocInvoice: (id, inv) => request(`${API}/invoices/adhoc/${id}`, { method: 'PUT', body: JSON.stringify(inv) }),
  deleteAdhocInvoice: (id) => authedFetch(`${API}/invoices/adhoc/${id}`, { method: 'DELETE' }),

  getNotes: (monthKey) => request(`${API}/notes/${monthKey}`),
  saveNotes: (monthKey, data) => request(`${API}/notes/${monthKey}`, { method: 'PUT', body: JSON.stringify(data) }),
};
